import {
  MessageAttributeValue,
  SQSClient,
  SendMessageCommand,
} from "@aws-sdk/client-sqs"
import { refPhytoBotanicalName } from "@tc/drizzle-v2"
import { DbTransaction } from "@tc/middy-decorators"
import { eq } from "drizzle-orm"
import { PhytoBotanicalNameDoc } from "../types/reference-data"
import { searchBuilderLog } from "../utils/logger"

const sqs_client = new SQSClient({})
const queue_url = process.env["PHYTO_BOTANICAL_NAME_QUEUE_URL"]

export const getRefPhytoBotanicalNameData = async (
  tx: DbTransaction,
  id: string,
): Promise<PhytoBotanicalNameDoc | undefined> => {
  const [row] = await tx
    .select({
      id: refPhytoBotanicalName.id,
      botanicalName: refPhytoBotanicalName.botanicalName,
      commonName: refPhytoBotanicalName.commonName,
      effectiveStartDate: refPhytoBotanicalName.effectiveStartDate,
      effectiveEndDate: refPhytoBotanicalName.effectiveEndDate,
      active: refPhytoBotanicalName.active,
      updatedAt: refPhytoBotanicalName.updatedAt,
      updatedBy: refPhytoBotanicalName.updatedBy,
    })
    .from(refPhytoBotanicalName)
    .where(eq(refPhytoBotanicalName.id, parseInt(id)))

  if (!row) {
    console.error(`RefPhytoBotanicalName with id ${id} not found`)
    return
  }

  const refPhytoBotanicalNameDoc: PhytoBotanicalNameDoc = {
    id: row.id.toString(),
    botanical_name: row.botanicalName,
    common_name: row.commonName?.trim() || "~~",
    effective_start_date: new Date(row.effectiveStartDate).getTime(),
    effective_end_date: row.effectiveEndDate
      ? new Date(row.effectiveEndDate).getTime()
      : 0,
    active: row.active,
    updated_at: row.updatedAt.getTime(),
    updated_by: row.updatedBy,
  }

  searchBuilderLog.debug({
    document: refPhytoBotanicalNameDoc,
  })

  return refPhytoBotanicalNameDoc
}

export const saveRefPhytoBotanicalNameToSearch = async (
  tx: DbTransaction,
  id: string,
  collectionName: string,
  options?: { returnDoc?: boolean },
): Promise<void> => {
  const doc = await getRefPhytoBotanicalNameData(tx, id)

  if (!doc || Object.keys(doc).length === 0) {
    console.error(`Failed to prepare document for id: ${id}`)
    return
  }

  if (options?.returnDoc) return doc as never

  const attributes: Record<string, MessageAttributeValue> = {
    collection: {
      StringValue: collectionName,
      DataType: "String",
    },
  }

  const command = new SendMessageCommand({
    QueueUrl: queue_url,
    MessageBody: JSON.stringify(doc),
    MessageAttributes: attributes,
  })

  await sqs_client.send(command)
}
